import axios from 'axios';
import { API_BASE_URL } from "../utils/envVariables";
import { getReduxData } from '../utils/share';
import { axiosInstance } from '../common/api';



export const fileUpload = async (folder, key, file) => {
    try {
        const { jwtToken } = getReduxData();


      const token = jwtToken ? `${jwtToken}` : undefined;
    
  
      const response = await axios.post(
        `${API_BASE_URL}/api/media`,
        {
          folder,
          fileName: key?.trim()?.replace(/\s+/g, '_') ?? key,
        },
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
  
      const fileUploadData = response?.data?.data;
  
      if (!fileUploadData || !fileUploadData.apiUrl) {
        throw new Error("Invalid upload data received");
      }
  
      // Convert file to binary data using FileReader
      const binaryData = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(new Error("Failed to read file"));
        reader.readAsArrayBuffer(file);
      });
      // Send binary data in PUT request
      await axios.put(fileUploadData.apiUrl, binaryData, {
        headers: {
          "Content-Type": file?.type || "application/octet-stream",
        },
        transformRequest: [(data) => data],
      });
  
      return fileUploadData;
    } catch (error) {
      console.error("Error during file upload:", error);
      throw error;
    }
  };
  
  export const getFileDownloadUrl = async (s3Key) => {
    try {
      const response = await axiosInstance.post(`/media/download-url`,{key:s3Key});
      return response.data.data.downloadUrl;
    } catch (error) {
      console.error('Error getting file download URL:', error);
      throw error;
    }
  };